<div [@showHide]="isOpened ? 'show' : 'hide'" [ngStyle]="options.customOverlay ? {'background':'transparent'} : {}"
  class="modal-overlay" id="modal-overlay">
  <div [@showHide]="isOpened ? 'show' : 'hide'" (click)="hide()" class="close-button">
    <i [ngStyle]="{'color': isOpened ? 'black' : ''}" class="material-icons">close</i>
  </div>
  <div class="modal-head" *ngIf="head">
    <ng-template *ngTemplateOutlet="head"></ng-template>
  </div>
  <div class="modal-body" #modalBody *ngIf="body">
    <ng-template *ngTemplateOutlet="body"></ng-template>
  </div>
  <div class="modal-footer" *ngIf="footer">
    <ng-template *ngTemplateOutlet="footer"></ng-template>
  </div>
</div>
<div [@showHide]="options.customOverlay ? 'show' : 'hide'" class="popup-overlay"></div>
